import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VersionNavComponent } from '../../shared/components/version-nav/version-nav.component';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-privacy',
  imports: [CommonModule, VersionNavComponent, HeaderComponent],
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.scss'
})
export class PrivacyComponent implements OnInit {
  currentDate = new Date();
  isAuthenticated = false;

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.isAuthenticated = this.authService.isAuthenticated() && !this.authService.isTokenExpired();
  }
}
